export const TRACKING_CONTEXT_SCHEMA = 'iglu:com.gitlab/gitlab_experiment/jsonschema/1-0-0';
export const DEFAULT_VARIANT = 'control';
export const CANDIDATE_VARIANT = 'candidate';
